var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-form__captcha"},[_c('load-script',{attrs:{"src":_vm.captchaApi}}),_vm._v(" "),_c('div',{staticClass:"g-recaptcha",attrs:{"id":_vm.captchaId}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }